<template>
  <div>
    <b-navbar :class="navbarClass">
      <!-- Brand section -->
      <template
        #brand
        v-if="brand"
      >
        <b-navbar-item
          tag="router-link"
          :to="brand.to"
        >
          <img
            v-if="brand.logo"
            :src="brand.logo"
            :alt="brand.alt || 'Logo'"
          />
          <span v-if="brand.text">{{ brand.text }}</span>
        </b-navbar-item>
      </template>

      <!-- Start section (left side) -->
      <template #start>
        <!-- Regular navbar items -->
        <template v-for="(item, index) in startItems">
          <!-- Regular item -->
          <b-navbar-item
            v-if="!item.dropdown"
            :key="`start-item-${index}`"
            :tag="item.action ? 'a' : 'router-link'"
            :to="!item.action ? item.to : undefined"
            @click="item.action ? handleAction(item.action) : null"
            :class="item.class"
          >
            <b-icon
              v-if="item.icon"
              :icon="item.icon"
            ></b-icon>
            <span>{{ item.label }}</span>
          </b-navbar-item>

          <!-- Dropdown item -->
          <b-navbar-dropdown
            v-else
            :key="`start-dropdown-${index}`"
            :label="item.label"
            :class="item.class"
          >
            <b-navbar-item
              v-for="(subItem, subIndex) in item.items"
              :key="`start-dropdown-item-${index}-${subIndex}`"
              :tag="subItem.action ? 'a' : 'router-link'"
              :to="!subItem.action ? subItem.to : undefined"
              @click="subItem.action ? handleAction(subItem.action) : null"
              :class="subItem.class"
            >
              <b-icon
                v-if="subItem.icon"
                :icon="subItem.icon"
              ></b-icon>
              <span>{{ subItem.label }}</span>
            </b-navbar-item>
          </b-navbar-dropdown>
        </template>
      </template>

      <!-- End section (right side) -->
      <template #end>
        <!-- Regular navbar items -->
        <template v-for="(item, index) in endItems">
          <!-- Regular item -->
          <b-navbar-item
            v-if="!item.dropdown"
            :key="`end-item-${index}`"
            :tag="item.action ? 'a' : 'router-link'"
            :to="!item.action ? item.to : undefined"
            @click="item.action ? handleAction(item.action) : null"
            :class="item.class"
          >
            <b-icon
              v-if="item.icon"
              :icon="item.icon"
            ></b-icon>
            <span>{{ item.label }}</span>
          </b-navbar-item>

          <!-- Dropdown item -->
          <b-navbar-dropdown
            v-else
            :key="`end-dropdown-${index}`"
            :label="item.label"
            :class="item.class"
            right
          >
            <b-navbar-item
              v-for="(subItem, subIndex) in item.items"
              :key="`end-dropdown-item-${index}-${subIndex}`"
              :tag="subItem.action ? 'a' : 'router-link'"
              :to="!subItem.action ? subItem.to : undefined"
              @click="subItem.action ? handleAction(subItem.action) : null"
              :class="subItem.class"
            >
              <div
                v-if="subItem.component"
                :is="subItem.component"
                v-bind="subItem.props"
              ></div>
              <template v-else>
                <b-icon
                  v-if="subItem.icon"
                  :icon="subItem.icon"
                ></b-icon>
                <span>{{ subItem.label }}</span>
              </template>
            </b-navbar-item>
          </b-navbar-dropdown>
        </template>

        <!-- Slot for additional end items -->
        <slot name="end-items"></slot>
      </template>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "BaseNavbar",

  props: {
    // Navbar styling
    navbarClass: {
      type: [String, Object, Array],
      default: "is-primary",
    },

    // Brand section
    brand: {
      type: Object,
      default: () => null,
    },

    // Left side items
    startItems: {
      type: Array,
      default: () => [],
    },

    // Right side items
    endItems: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    handleAction(action) {
      if (typeof action === "function") {
        action();
      } else if (typeof action === "string") {
        this.$emit("action", action);
      }
    },
  },
};
</script>

<style scoped>
.navbar-item img {
  max-height: 32px;
}

.navbar-item figure.image {
  margin-right: 0.5rem;
}
</style>
